import theme from '../../../../../../lib/theme';
import { TypeaheadProps } from './Typeahead';

const inputHeights = {
  m: 40,
  l: 50,
};

const {
  corners,
  inputReset,
  scale,
  colors,
  layers,
  font: { families, heights, spacings, ...font },
} = theme;

export default ({
  brand = 'sas',
  status,
  size = 'm',
  expanded,
}: TypeaheadProps) => ({
  container: {
    position: 'relative',
  },

  suggestions: {
    position: 'absolute',
    left: 0,
    zIndex: layers.higher,
    backgroundColor: colors.white,
    borderRadius: `0 0 ${corners.m} ${corners.m}`,
    border: `1px solid ${colors.grey}`,
    overflow: 'auto',
    maxHeight: 200,
    width: '100%',
    boxShadow: '6px 5px 8px rgb(0 0 0 / 20%)',

    '& > *': {
      borderTop: `1px solid ${colors.grey}`,
    },

    '& > *:first-child': {
      borderTop: 'none',
    },
  },
  
  suggestion: {
    display: 'block',
    padding: `${scale.xs} ${scale.s}`,
    cursor: 'pointer',
    color: colors.black,
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    letterSpacing: spacings.m,
    transition: 'color 150ms linear',

    '&:hover': {
      color: colors[brand].accent,
    },

    '.highlight': {
      backgroundColor: colors[brand].secondary,
    },
  
  },

  empty: {
    display: 'block',
    padding: `${scale.xs} ${scale.s}`,
    color: colors.black,
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    letterSpacing: spacings.m,
  },

  input: {
    ...inputReset,

    backgroundColor: colors.white,
    outline: 'none',
    border: `1px solid ${status ? colors[status] : colors.grey}`,
    borderRadius: expanded ? `${corners.m} ${corners.m} 0 0` : corners.m,
    fontFamily: families.primary,
    color: colors.dark_grey,
    padding: `${scale.xs} ${scale.s}`,
    width: '100%',
    height: inputHeights[size],

    '&:focus': {
      borderColor: colors.focus,
    },
  },

  required: {
    color: colors.bad,
    paddingLeft: scale.xxxs,
  },

  favouritesHeading: {
    marginBottom: `0.5rem`,
  },
});
